
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IChiaPhongTheoSoPhongRequest } from "../../../model/request/tct/IChiaPhongTheoSoPhongRequest";
import { IChiaSinhVienVaoPhongRequest } from "../../../model/request/tct/IChiaSinhVienVaoPhongRequest";
import { IPhongThiChiaThuCongRequest } from "../../../model/request/tct/IPhongThiChiaThuCongRequest";
import { IDuKienMoPhong } from "../../../model/respone/tct/IDuKienMoPhong";
import { IDuKienMoPhongViewModel } from "../../../model/respone/tct/IDuKienMoPhongViewModel";
import { IPhongThi } from "../../../model/respone/tct/IPhongThi";
import { IPhongThiVm } from "../../../model/respone/tct/IPhongThiVm";
import { IPhongThiFilter, IPhongThiFilters } from "../../reducer-model/tct/IPhongThiReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IPhongThiActionTypeBase<T> {
    dotThiId: number,
    data: T
}
export const ePhongThiActionsObj = {
    CHANGE_DOT_THI_ID: {} as IPhongThiActionTypeBase<undefined>,

    LOAD_START: {} as IPhongThiActionTypeBase<undefined>,
    LOAD_SUCCESS: {} as IPhongThiActionTypeBase<IPhongThiVm[]>,
    LOAD_ERROR: {} as IPhongThiActionTypeBase<string>,

    SHOW_EDIT_MODAL: {} as IPhongThiActionTypeBase<IPhongThi | undefined>,
    CLOSE_EDIT_MODAL: {} as IPhongThiActionTypeBase<undefined>,

    SAVE_START: {} as IPhongThiActionTypeBase<IPhongThi>,
    SAVE_SUCCESS: {} as IPhongThiActionTypeBase<IPhongThi>,
    SAVE_ERROR: {} as IPhongThiActionTypeBase<string>,

    DELETE_START: {} as IPhongThiActionTypeBase<IIdsRequest>,
    DELETE_SUCCESS: {} as IPhongThiActionTypeBase<IIdsRequest>,
    DELETE_ERROR: {} as IPhongThiActionTypeBase<string>,

    CHANGE_SELECTED_IDS: {} as IPhongThiActionTypeBase<number[]>,

    CHIA_THUC_CONG_START: {} as IPhongThiActionTypeBase<IPhongThiChiaThuCongRequest>,
    CHIA_THUC_CONG_SUCCESS: {} as IPhongThiActionTypeBase<IPhongThi[]>,
    CHIA_THUC_CONG_ERROR: {} as IPhongThiActionTypeBase<string>,

    UPDATES_START: {} as IPhongThiActionTypeBase<IPhongThi[]>,
    UPDATES_SUCCESS: {} as IPhongThiActionTypeBase<IPhongThi[]>,
    UPDATES_ERROR: {} as IPhongThiActionTypeBase<string>,

    CHANGE_FILTER: {} as IPhongThiActionTypeBase<IPhongThiFilter>,
    CHANGE_FILTERS: {} as IPhongThiActionTypeBase<IPhongThiFilters>,

    ID_DOT_THI_PHONG_CHANGED: {} as IPhongThiActionTypeBase<number>,
    
    UPDATE_FIELD_CHANGED: {} as IPhongThiActionTypeBase<{ id_dot_thi_phongs: number[], field: string, value: any }>,

    DU_KIEN_MO_PHONG_START: {} as IPhongThiActionTypeBase<undefined>,
    DU_KIEN_MO_PHONG_SUCCESS: {} as IPhongThiActionTypeBase<IDuKienMoPhongViewModel[]>,
    DU_KIEN_MO_PHONG_ERROR: {} as IPhongThiActionTypeBase<string>,

    UPDATE_DU_KIEN_MO_PHONG_START: {} as IPhongThiActionTypeBase<IDuKienMoPhong[]>,
    UPDATE_DU_KIEN_MO_PHONG_SUCCESS: {} as IPhongThiActionTypeBase<IDuKienMoPhong[]>,
    UPDATE_DU_KIEN_MO_PHONG_ERROR: {} as IPhongThiActionTypeBase<string>,

    CHIA_PHONG_THEO_SO_LUONG_PHONG_START: {} as IPhongThiActionTypeBase<IChiaPhongTheoSoPhongRequest>,
    CHIA_PHONG_THEO_SO_LUONG_PHONG_SUCCESS: {} as IPhongThiActionTypeBase<undefined>,
    CHIA_PHONG_THEO_SO_LUONG_PHONG_ERROR: {} as IPhongThiActionTypeBase<string>,

    CHIA_SINH_VIEN_VAO_PHONG_START: {} as IPhongThiActionTypeBase<IChiaSinhVienVaoPhongRequest>,
    CHIA_SINH_VIEN_VAO_PHONG_SUCCESS: {} as IPhongThiActionTypeBase<undefined>,
    CHIA_SINH_VIEN_VAO_PHONG_ERROR: {} as IPhongThiActionTypeBase<string>,
};
export const ePhongThiActionIds = generateActionTypeIds(
    ePhongThiActionsObj,
    "PHONG_THI"
);
export type IPhongThiActionTypes = IGenericActionType<
    typeof ePhongThiActionsObj,
    "PHONG_THI"
>;
